import arrowRightIcon from '../../assets/icons/arrowRight.svg';
import { IArtCategoryArtist } from '../../types/artwork';

import styles from './styles.module.css';
import { Link } from 'react-router-dom';

interface IArtCategoryCardProps {
    title: string;
    artists: IArtCategoryArtist[];
    imageSrc: string;
}

// TODO: добавить нормальную линку на страницу поиска по категории

export const ArtCategoryCard: React.FC<IArtCategoryCardProps> = (props) => {
    const { title, artists, imageSrc } = props;

    return (
        <div className={styles.container}>
            <div className={styles.titleContainer}>
                <span className={styles.title}>{title}</span>
                <Link to="/">
                    <img className={styles.arrow} src={arrowRightIcon} alt="See more"/>
                </Link>
            </div>
            <img className={styles.photo} src={imageSrc} alt="Example artwork"/>
            {artists.map((artist, index) => {
                return (
                    <div key={index} className={styles.artist}>
                        <a href={artist.href} className={styles.artistLink}>
                            {artist.name}
                        </a>
                    </div>
                )
            })}
        </div>
    );
}